type LoadedContent = {
  loading: boolean;
  content: string | undefined;
  truncated: boolean;
};

// Why a run's input/output can't be pinned as a step test, or null if it
// can. The content must be loaded, inline (text/JSON/HTTP, so `content` is
// defined), and small enough to inline (not truncated).
export function pinContentIssue(
  output: LoadedContent,
  input: LoadedContent
): string | null {
  if (output.loading || input.loading) return "Loading this run’s output…";
  if (output.truncated || input.truncated)
    return "This run’s input or output is too large to pin as a step test.";
  if (output.content === undefined || input.content === undefined)
    return "Step tests are only available for runs with text, JSON, or HTTP input and output.";
  return null;
}
